import { useMutation } from 'react-query';
import { JsonObject } from 'type-fest';

import { useRequest, type MutationFunction } from '../common';

export type UseCreateSubquoteData = {
  groupBusinessName: string;
  groupId: number;
  id: number;
  number: number;
}[] &
  JsonObject;

export type UseCreateSubquoteRequestVars = {
  quoteId: number;
  groupIds: number[];
  notes?: string;
};

export const useCreateSubquote: MutationFunction<
  UseCreateSubquoteData,
  UseCreateSubquoteRequestVars
> = ({ query, requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);
  return useMutation(
    ({ quoteId, ...body }) =>
      request(`/quotes/${quoteId}/subquote`, {
        query,
        init: {
          method: 'POST',
          body,
        },
      }),
    queryOptions,
  );
};
